import { render, staticRenderFns } from "./ASC_ByHCCV28Printable.vue?vue&type=template&id=0b2b1b2c&scoped=true&"
import script from "./ASC_ByHCCV28Printable.vue?vue&type=script&lang=js&"
export * from "./ASC_ByHCCV28Printable.vue?vue&type=script&lang=js&"
import style0 from "./ASC_ByHCCV28Printable.vue?vue&type=style&index=0&id=0b2b1b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b1b2c",
  null
  
)

export default component.exports